import { useState } from 'react';
import type { CreateUserRequest, CreateUserResponse } from 'vopay';
import { api } from '@/services/api.config';

export default function useCreateUser() {
  const [submitting, setSubmitting] = useState(false);

  async function createUser(params: CreateUserRequest): Promise<CreateUserResponse> {
    try {
      setSubmitting(true);
      const res = await api.postCreateUser(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error('Create user failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, createUser };
}
